<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';

    export default {
        CalendarMonth: defineAsyncComponent(() => import(/* webpackChunkName: "ui-month" */'@/components/UI/Calendar/Month.vue')),
        CalendarStartWedge: defineAsyncComponent(() => import(/* webpackChunkName: "ui-month" */'@/components/UI/Calendar/StartWedge.vue')),
        CalendarDividerWedge: defineAsyncComponent(() => import(/* webpackChunkName: "ui-month" */'@/components/UI/Calendar/DividerWedge.vue')),
        CalendarEndWedge: defineAsyncComponent(() => import(/* webpackChunkName: "ui-month" */'@/components/UI/Calendar/EndWedge.vue')),
        CalendarFullWedge: defineAsyncComponent(() => import(/* webpackChunkName: "ui-month" */'@/components/UI/Calendar/FullWedge.vue')),
    }
</script>